import { z } from 'zod';

export const homeSectionSchema = z.object({
  key: z.string(),
});

export const homeSectionsResponseSchema = z.object({
  sections: z.array(homeSectionSchema),
});

export type HomeSection = z.infer<typeof homeSectionSchema>;
export type HomeSectionsApi = z.input<typeof homeSectionsResponseSchema>;
